export default "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsKCi53ZWJob29rLXNsaWRlLXBhbmVsIHsKfQo="